<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
    <template v-if="!loading && detail">
      <div>
        <h5>Препарат <strong>{{ drug.title }}</strong></h5>
        <h6>редактирование атрибута <strong>{{ detail.title }}</strong></h6>
      </div>
      <div>
        <table class="table table-hover table-sm mt-1">
          <thead>
          <tr>
            <th>Проект</th>
            <th>Значение</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="p in $AllProjects" v-if="p.is_active && !p.settings.no_site && details[p.id]"
              :class="{'not_active': !drugActivity[p.id]}">
            <td>{{ p.title }}</td>
            <td>
              <template v-if="!drugActivity[p.id]">
                <p>Препарат не активен на проекте</p>
              </template>
              <template v-else>
                <template v-if="detail.type === 'array'">
                  <template v-if="sitesSelects && sitesSelects[p.id]?.options">
                    <multiselect
                      v-model="details[p.id].array_value"
                      :options="sitesSelects && sitesSelects[p.id]?.options || []"
                      @input="(e) => {}"
                      placeholder="Выберите деталь"
                      track-by="name"
                      label="name"
                      :showLabels="false"
                      :searchable="true"
                      :multiple="!!detail.is_multiple"/>
                  </template>
                  <template v-else-if="allowToCreate">
                    <multiselect
                      v-model="details[p.id].array_value"
                      tag-placeholder="Выберите или создайте запись"
                      placeholder="Выберите или создайте запись"
                      :options="[]"
                      :multiple="true"
                      :taggable="true"
                      @tag="(t) => {details[p.id].array_value.push(t)}"/>
                  </template>
                  <template v-else>
                    <p>выбор деталей не найден на проекте</p>
                  </template>
                </template>
                <template v-if="detail.type === 'text'">
                  <textarea rows="2" v-model="details[p.id].value" type="text" class="form-control"/>
                </template>
              </template>
            </td>
            <td></td>
          </tr>
          </tbody>
        </table>
        <div class="text-right">
          <LoadingButton
            title="Сохранить"
            :loading="btnLoading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => saveRecords()"
            className="btn btn-outline-success"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Multiselect from 'vue-multiselect'

export default {
  props: ['drugId', 'drugDetailId'],
  components: {
    LoadingButton,
    Multiselect,
  },
  data() {
    return {
      allowToCreate: false,
      loading: false,
      btnLoading: false,
      drug: {},
      drugActivity: {},
      detail: null,
      details: {},
      sitesSelects: {},
      optionsKeys: {
        id_illness: ['illness', 'illnesses']
      },
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {});
    },
  },
  created() {
    this.getDetails()
  },
  methods: {
    async saveRecords() {
      this.btnLoading = true;

      let details = {...this.details}
      if (this.detail.type === 'array') {
        details = Object.keys(details).reduce((acc, p) => {
          acc[p] = {...details[p], value: (details[p].array_value || []).map((v) => v?.id || v)}
          return acc;
        }, {})
      }

      const {data} = await api.post('/new/drugs/siteDetail', {
        action: 'updateData',
        drug_id: this.drugId,
        detail_id: this.drugDetailId,
        drug_activity: this.drugActivity,
        details: details,
      });
      if (data.success) {
        const errors = [];
        Object.keys(data.site_responses).forEach((projectId) => {
          if (!data.site_responses[projectId] || !data.site_responses[projectId].success) {
            errors.push(this.$AllProjects[projectId].title + ' ' + (data.site_responses[projectId]?.error || data.site_responses[projectId]?.message || 'нет ответа'));
          }
        })
        if (errors.length) {
          toastr['warning']("Ошибки обновления\n" + errors.join("\n"));
        } else {
          toastr['success']('Обновлено', 'Успешно');
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    },
    async getDetails() {
      this.loading = true;
      const {data} = await api.post('/new/drugs/siteDetail', {
        action: 'getAllSitesData',
        drug_id: this.drugId,
        detail_id: this.drugDetailId
      });
      if (data.success) {
        const index = this.optionsKeys[data.detail.alias];
        // console.log(this.optionsKeys, data.detail.alias, index);
        this.sitesSelects = Object.keys(data.site_selects).reduce((acc, p) => {
          Object.keys(data.site_selects[p]).forEach((a) => {
            if ((index || []).includes(a)) {
              if (!acc[p]) acc[p] = {};
              acc[p].options = data.site_selects[p][a];
            }
          });
          return acc;
        }, {});

        if (!data.detail.id_track) this.allowToCreate = true;
        this.details = Object.values(this.$AllProjects).reduce((acc, p) => {
          if (!p.is_active || p.settings.no_site) return acc;
          if (p.id === 7) return acc;
          acc[p.id] = data.site_data.find((d) => d.site_id === p.id) || {};
          if (data.detail.type === 'array') {
            if (this.sitesSelects[p.id]?.options) {
              acc[p.id].array_value = this.sitesSelects[p.id].options.filter((o) => (acc[p.id].array_value || []).includes(o.id) || (acc[p.id].array_value || []).includes(o.id + ''));
            }
            acc[p.id].array_value = (acc[p.id].array_value || []).filter((o) => o);
            acc[p.id].value = (acc[p.id][data.detail.type + '_value'] || []).join(',');
          } else {
            acc[p.id].value = acc[p.id][data.detail.type + '_value'] || null;
          }
          acc[p.id].type = data.detail.type;
          return acc;
        }, {});
        this.drugActivity = data.drug.prices.reduce((acc, p) => {
          acc[p.site_id] = p.is_active;
          return acc;
        }, {})
        this.drug = data.drug;
        this.detail = data.detail;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table tr.not_active {
  background-color: #e6e6e6;
}

table.table tr.not_active td {
  padding: 5px;
}

table.table td {
  padding: 3px;
}
</style>
